import Vue from 'vue'
import Vuex from 'vuex'
import app from '../../main'
import checkResponse from '@/utils/checkResponse'
import axios from 'axios'
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id,
  project_id: payload.project.id,
  product_amount: payload.product_amount,
  user_id: app.$auth.user().id
})
var crud = new Crud('Requisitions', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  requisition: [],
  suppliesShipped: [],
  requisitions: [],
  catalog: {
    projects: [],
    users: []
  },
  isModalImportRequisitionDetailVisible: false
}

const mutations = {
  ...crud.mutations,
  SET_REQUISITION (state, payload) {
    state.requisition = payload.data
  },
  SET_MODAL_IMPORT_REQUISITION_DETAIL_VISIBLE (state, payload) {
    state.isModalImportRequisitionDetailVisible = payload
  },
  ADD_SUPPLIES_SHIPPED (state, payload) {
    const idx = state.suppliesShipped.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.set(state.suppliesShipped, idx, payload)
    }
  },
  DELETE_SUPPLIES_SHIPPED (state, payload) {
    const idx = state.suppliesShipped.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.suppliesShipped, idx)
    }
  }
}

const actions = {
  ...crud.actions,
  setModalImportRequisitionDetailVisible ({ commit }, payload) {
    commit('SET_MODAL_IMPORT_REQUISITION_DETAIL_VISIBLE', payload)
  },
  async loadRequisition ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`requisitions/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_REQUISITION', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async downloadTemplateDetail ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(`${Vue.axios.defaults.baseURL}/requisition-details/template`)
    } catch (error) {
      app.$Progress.fail()
    } finally {
      app.$Progress.finish()
    }
  },
  async importRequisitionDetail ({ commit }, payload) {
    let formData = new FormData()
    formData.append('importFile', payload.file[0])
    app.$Progress.start()

    try {
      const response = await axios.post(`requisitions/${payload.id}/details/import`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_MODAL_IMPORT_REQUISITION_DETAIL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.requisition_detail', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  addProductToPurcharseOrder ({ commit }, payload) {
    commit('PurchaseOrders/ADD_PRODUCT', { ...payload }, { root: true })
  },
  setModalOrderVisible ({ commit }, payload) {
    commit('PurchaseOrders/SET_MODAL_ORDER_VISIBLE', payload, { root: true })
  },
  setModalSessionOrderVisible ({ commit }, payload) {
    commit('PurchaseOrders/SET_MODAL_SESSION_ORDER_VISIBLE', payload, { root: true })
  },
  setLoaderVisible ({ commit }, payload) {
    commit('Quotations/SET_LOADER_VISIBLE', payload, { root: true })
  }
}

const getters = {
  ...crud.getters,
  requisition: state => state.requisition,
  requisitions: state => state.requisitions,
  suppliesShipped: state => state.suppliesShipped,
  isModalImportRequisitionDetailVisible: state => state.isModalImportRequisitionDetailVisible,
  purchaseOrder: (state, getters, rootState, rootGetters) => rootGetters['PurchaseOrders/purchaseOrder'],
  loader: (state, getters, rootState, rootGetters) => rootGetters['Quotations/loader']
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
